import { useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "src/auth";
import { FullPageLoading } from "src/components";

import { entities, plainToInstance } from "@fraction/shared";

import { useQueryParams } from "src/hooks";
import Layout from "./Layout";

const Login = () => {
  const { login, isLoggingIn, isLoadingUser, isAuthenticated } = useAuth();
  const location = useLocation();
  const { redirect } = useQueryParams();

  const onSubmit = useCallback((submission?: Record<string, string>) => {
    login(plainToInstance(entities.User, submission));
  }, []);

  if (isLoadingUser) {
    return <FullPageLoading />;
  }

  if (isAuthenticated) {
    return <Navigate to={redirect || location?.state?.from || "/"} replace />;
  }

  return <Layout onSubmit={onSubmit} isLoading={isLoggingIn} />;
};

export default Login;
